import { render, staticRenderFns } from "./Bestelldetails.vue?vue&type=template&id=282dbf87&scoped=true&"
import script from "./Bestelldetails.vue?vue&type=script&lang=js&"
export * from "./Bestelldetails.vue?vue&type=script&lang=js&"
import style0 from "./Bestelldetails.vue?vue&type=style&index=0&id=282dbf87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282dbf87",
  null
  
)

export default component.exports